import React from 'react';
import { Link, useParams, useLocation } from 'react-router-dom';

export default function Footer(props) {
	return (
		<React.Fragment>
			<footer className="bg-gray-100">
				<hr />
				<div className="container p-6 pb-2 md:pt-10 md:px-20">
					<div className="grid grid-cols-1 md:grid-cols-3 gap-10">
						<div className="mt-6 md:mt-0">
							<span className="font-semibold">Support</span>
							<ol className="mt-4">
								<Link to="/help">
									<li className="my-4 hover:underline">Help Center</li>
								</Link>
								<li className="my-4">Report an issue</li>
								<li className="my-4">Visit our blog</li>
							</ol>
						</div>
						<div className="mt-6 md:mt-0">
							<span className="font-semibold">Community</span>
							<ol className="mt-4">
								<li className="my-4">Combating homelessness</li>
							</ol>
						</div>
						<div className="mt-6 md:mt-0">
							<span className="font-semibold">Travltax</span>
							<ol className="mt-4">
								<li className="my-4">Learn about new features</li>
								<li className="my-4">A word from our founders</li>
								<li className="my-4">Our roadmap</li>
							</ol>
						</div>
					</div>
					<div className='block mt-6'>
						<hr />
						<p className="py-4">© Travltax, LLC 2025</p>
						<p className="py-4">All rights reserved.</p>
					</div>
				</div>
			</footer>
		</React.Fragment>
	);
}
